import { Controller } from 'stimulus';

/**
 * Disables already-selected options across sibling <select>
 * elements within a cocoon nested fields container, preventing
 * duplicate selections.
 */
export default class extends Controller {
  static targets = ['select'];

  connect() {
    this.element.addEventListener('cocoon:after-insert', this.sync);
    this.element.addEventListener('cocoon:after-remove', this.sync);
    this.sync();
  }
  disconnect() {
    this.element.removeEventListener('cocoon:after-insert', this.sync);
    this.element.removeEventListener('cocoon:after-remove', this.sync);
  }
  sync = () => {
    const selects = this.selectTargets.filter(
      (s) => s.closest('.nested-fields')?.style.display !== 'none'
    );

    const selectedValues = new Set(
      selects.map((s) => s.value).filter((v) => v !== '')
    );

    selects.forEach((select) => {
      const currentValue = select.value;

      Array.from(select.options).forEach((option) => {
        if (option.value === '') return;

        option.disabled =
          option.value !== currentValue && selectedValues.has(option.value);
      });
    });
  };
}
